import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=61824c9d&scoped=true"
import script from "@/scripts/dashboard/dashboard.js?vue&type=script&lang=js&external"
export * from "@/scripts/dashboard/dashboard.js?vue&type=script&lang=js&external"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=61824c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61824c9d",
  null
  
)

export default component.exports